import { combineReducers } from "redux";
import alerta from "./alertas/alerta";
import analise from "./alertas/analise";
import audiencia from "./alertas/audiencia";
import dadoParametrizado from "./alertas/dadoParametrizado";
import geo from "./alertas/geo";
import auth from "./auth";
import download from "./comum/download";
import loading from "./comum/loading";
import daca from "./daca";

const reducers = combineReducers({
	dadoParametrizado,
	alerta,
	daca,
	audiencia,
	analise,
	loading,
	geo,
	download,
	auth
});

export default reducers;
